import Swiper from "swiper";
var swiper = new Swiper(".related-news-swiper-container", {
	breakpoints: {
		simulateTouch: true,
		draggable: true,
		320: {
			slidesPerView: 1.1,
			spaceBetween: 10,
		},
		992: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
	},
});
